/**
 * This is the logout module configuration.
 * Do NOT configure routes in this file.
 * @memberOf Logout Module
 * @namespace Logout Config
 */

/**
 * @name config
 * @desc Configures the module.
 * @memberOf Logout Module.Logout Config
 * @ngInject
 */
var config = function () {
}

export default config;


// WEBPACK FOOTER //
// ./src/logout/logout.config.js